var map = {
	"./Ubouw A1.jpg": 2707,
	"./Ubouw A2.jpg": 8228,
	"./Ubouw B1.jpg": 9902,
	"./Ubouw B2.jpg": 6041,
	"./Ubouw B3.jpg": 8668,
	"./Ubouw B4.jpg": 2455,
	"./Ubouw C1.jpg": 3129,
	"./Ubouw C2.jpg": 6398,
	"./Ubouw C3.jpg": 7883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7082;